import "../Polyfills/Fetch";
import * as Utils from "./Utils";

export const FETCH_TIMEOUT = 5000;

export function sendGetRequest(requestUrl: string, token?: string, sessionId?: string,
	useTimeout?: boolean, timeout?: number): Promise<Response> {
	const requestInit = {
		method: "GET",
		headers: createHeaders(token, null, sessionId),
	};

	return useTimeout ?
		timeoutFetch(requestUrl, requestInit, timeout ?? FETCH_TIMEOUT) :
		fetch(requestUrl, requestInit);
}

export function sendPostRequest(
	requestUrl: string, requestBody: string, token?: string, requestHeaders?: Record<string, string>, sessionId?: string,
	useTimeout?: boolean, timeout?: number): Promise<Response> {
	const requestInit = {
		method: "POST",
		headers: createHeaders(token, requestHeaders, sessionId),
		body: requestBody,
	};

	return useTimeout ?
		timeoutFetch(requestUrl, requestInit, timeout ?? FETCH_TIMEOUT) :
		fetch(requestUrl, requestInit);
}

function createHeaders(token?: string, requestHeaders?: Record<string, string>, sessionId?: string): Headers {
	const headers: Headers = typeof Headers !== "undefined" && new Headers();

	if (headers) {
		if (!Utils.isNOU(token)) {
			headers.append("Authorization", "Bearer " + token);
		}

		if (!Utils.isNOU(requestHeaders)) {
			for (const key in requestHeaders) {
				if (Object.prototype.hasOwnProperty.call(requestHeaders, key)) {
					headers.append(key, requestHeaders[key]);
				}
			}
		}

		headers.append("X-CorrelationId", Utils.guid());
		if (sessionId) {
			headers.append("X-ClientSessionId", sessionId);
		}
	}

	return headers;
}

function timeoutFetch(input: RequestInfo, init: RequestInit = {}, timeout: number): Promise<Response> {
	return new Promise((resolve, reject) => {
		fetch(input, init).then(resolve, reject);
		setTimeout(() => reject(new Error("Service request timed out")), timeout);
	});
}
